/* global angular, $ */
angular.module('ua5App')
    .directive('resourceTourform', ['$state', '$timeout', '$rootScope', '$sce', 'PostFactory', 'FormsFactory', function($state, $timeout, $rootScope, $sce, PostFactory, FormsFactory) {
        return {
            restrict: 'A',
            templateUrl: 'components/resource-tourform/resource-tourform.html',
            scope: {
                sectionIndex: '@'
            },
            link: function($scope, element, attrs) {
                var fields = [
                    'event',
                    'nameFirst',
                    'nameLast',

                    'email',
                    'attendee',
                    'level',
                    'year',
                    'major',
                    'guests'
                ];

                $scope.tours = [];

                function getEvents() {

                    var startDateObj = {};
                    var queryObj = {};

                    startDateObj.date = new Date();
                    startDateObj.day = startDateObj.date.getDate();
                    startDateObj.month = startDateObj.date.getMonth() + 1;
                    startDateObj.year = startDateObj.date.getFullYear();
                    startDateObj.shortString =  startDateObj.year + '-' + startDateObj.month + '-' +  startDateObj.day;

                    queryObj = {
                        category: 'event',
                        start: startDateObj.shortString,
                        end: (startDateObj.year + 10) + '-' + startDateObj.month + '-' +  startDateObj.day,  // this is 10 yrs from today
                        eventtype: 'campus tour',
                        allowHidden: true
                    };

                    PostFactory.calendarPosts().query(queryObj).$promise.then(function(events) {
                        for (var i = 0; i < events.length; i++) {
                            events[i].dateObj = new Date(events[i].eventData.startDate);
                        }
                        $scope.tours = events;
                        $timeout(function() {
                            $('.openFormLink', element).click(function() {
                                var $$linkElement = $(this);
                                if ($$linkElement.parent().hasClass('hasForm')) {
                                    $$linkElement.parent().removeClass('hasForm');
                                    $('#tour-rsvp-form').slideUp(200);
                                } else {
                                    if ($('.hasForm', element).length > 0) {
                                        $('.hasForm', element).removeClass('hasForm');
                                        $$linkElement.parent().addClass('hasForm');
                                        $('#tour-rsvp-form').slideUp(200, function() {
                                            $$linkElement.parent().next('.tour-rsvp-form-holder').append($('#tour-rsvp-form'));
                                            $('#tour-rsvp-form').slideDown(200);
                                        });
                                    } else {
                                        $$linkElement.parent().addClass('hasForm');
                                        $$linkElement.parent().next('.tour-rsvp-form-holder').append($('#tour-rsvp-form'));
                                        $('#tour-rsvp-form').slideDown(200);
                                    }
                                }
                            });
                        });
                    });
                }

                getEvents();

                $scope.inputFocus = {};
                for (var i = 0; i< fields.length; i++) {
                    $scope.inputFocus[fields[i]] = false;
                }

                $('.resource-connectform').find('label').each(function() {
                    if (!$(this).hasClass('resources-connectform__label-long')) {
                        var w = $(this).width(),
                            paddingW = w + 20 + 'px';

                        if ($(this).hasClass('resources-connectform__label-dropdown')) {
                            $(this).next().css('margin-left', paddingW);
                            $(this).next().css('width', 'calc( 100% - ' + paddingW + ')');
                        } else {
                            $(this).next().css('text-indent', paddingW);
                        }
                    }
                });

                $('label', element).click(function() {
                    var labelID = $(this).attr('for');
                    $('#' + labelID).trigger('click');
                });

                $scope.submitTour = function() {

                    var tForm = $scope.tourForm;

                    if ($scope.tourForm.$invalid) {
                        alert('Please fill in all the fields.');
                    } else {
                        FormsFactory.rsvp({
                            event: tForm.event.$modelValue,
                            firstname: tForm.nameFirst.$modelValue,
                            lastname: tForm.nameLast.$modelValue,
                            email: tForm.email.$modelValue,
                            attendee: tForm.attendee.$modelValue,
                            entrylevel: tForm.level.$modelValue,
                            entryyear: tForm.year.$modelValue,
                            intendedmajor: tForm.major.$modelValue,
                            guestsattending: tForm.guests.$modelValue
                        }).then(function(response) {
                            if (response.data && response.data.Errors) {
                                // error handling
                                alert(response.data.Errors.join('\n'));
                            } else if (response.data) {
                                // success;
                                $('.tour-rsvp-form').hide();
                                $('.hasForm .openFormLink', element).click();
                                $state.go('info', {
                                    tour: $('#tour-form__date-and-time option:selected').text().replace(/\./g, ''),
                                    guests: $('#tour-form__guests option:selected').text().replace(/\./g, '')
                                });
                            } else {
                                // unknown error
                                alert('An error occured, please try submitting your form again.');
                            }
                        });
                    }
                };

                $timeout(function() {
                    //$('#tour-rsvp-form').hide();
                    $rootScope.$broadcast('resourceComponentPosition', {sectionIndex: $scope.sectionIndex});
                });
            }
        };
    }])
;
